import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json'
import Utilis from '../../../Models/Utilis';
import DistantProfils from '../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import { Typography } from '@mui/material';
import MLimite from '../../../Models/MLimite';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import { Console } from 'console';
import { useTranslation } from "react-i18next";
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearchInput from "../../SearchInput";
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import { Box } from "@mui/material";
import formatDate from '../../../Functions/Traitement/fomatDate';


const AddLimite = () => {
  // USER SESSION
  const auth = useAuthUser()
  const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))

  let searchLim: ParamsPicklist = { CodeAgence: Perss.codage, Table: "LIMITE", Colonne1: "IDLIMITE", Colonne2: "IDCLIENT", Colagence: "codeage", colfiltre: "", valfiltre: '', Choix: 22 }
  let searchClient: ParamsPicklist = { CodeAgence: Perss.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", colfiltre: "", valfiltre: '', Choix: 22 }
  //let searchNum: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "AGCCPT",colfiltre:"TYPCPT",valfiltre:'I', Choix: 22 }


  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [Reference, SetReference] = useState(false)

  //* *********** news  11 1 11 1 1 
  const [Consultactv, setConsulte] = useState(false);
  const [Ajoutactv, setAjoute] = useState(false);
  const [Modifactv, setModife] = useState(true);
  const [Supprimactv, setSupprime] = useState(true);
  const [Enregactv, setEnrege] = useState(true);
  const [Actuactv, setActue] = useState(true);
  const [Annulactv, setAnnule] = useState(true);
  const [FormAct, setFormactve] = useState(true);
  const [Idbutton, setIdbutton] = useState(false);
  const [Idlibell, setIdlibell] = useState(false);

  const { t, i18n } = useTranslation();

  let FormLimite = {
    NumOdre: t("FormLimite.NumOrde"),
    Idclient: t("FormLimite.Idclient"),
    Mntlim: t("FormLimite.Mntlim"),
    Nivcons: t("FormLimite.Nivcons"),
    datedebut: t("FormLimite.datedebut"),
    datefin: t("FormLimite.datefin")
  }

  useEffect(() => {
    forceUpdate({});
  }, []);

  // function initialiazeButton() {
  //   setAjoutActif(true)
  //   setModifActve(true)
  //   setEnregActve(true)
  //   setSupActive(true)
  //   setImpActive(true)
  //   setActActive(true)
  //   setAnnulActive(true)
  //   setConsulActive(false)
  // }

  // const SetStart = () => {
  //   setSbmit("add")
  //   setAjoutActif(true)
  //   setEnregActve(false)
  //   setAnnulActive(false)
  //   setConsulActive(true)
  //   form.resetFields()
  //   //form.setFieldValue("niveau", 900)
  // }

  // const SetEndStart = () => {
  //   SetStartForm(true);
  //   SeStartSearchG(false)
  // }
  // function handleAnulle() {
  //   let coduti = form.getFieldValue("CODUTI")
  //   form.resetFields()
  //   localStorage.clear()
  //   form.setFieldValue("CODUTI", coduti)
  //   initialiazeButton()
  //   localStorage.setItem(Data.LocalVariable.reset, "1")

  //   SetReference(false)
  // }
  // function cunsultButton() {
  //   setAnnulActive(false)
  //   setModifActve(false)
  //   setAjoutActif(true)
  //   setSupActive(false)
  //   setConsulActive(true)
  //   SetReference(true)
  // }

  // function modifButton() {
  //   setSbmit("update")
  //   setModifActve(true)
  //   setAjoutActif(true)
  //   setEnregActve(false)
  //   setConsulActive(true)
  // }

  //*************************** New Handle *******************/
  // Handle function
  function HandleConsult() {
    setConsulte(true);
    setAjoute(true);
    setModife(false);
    setAnnule(false);
    setSupprime(false)
    setIdbutton(true)
  }

  function HandleAjout() {
    setConsulte(true);
    setAjoute(true);
    setEnrege(false);
    setActue(false);
    setAnnule(false);
    setFormactve(false);
    setSbmit('add');
    setIdlibell(false);
    setIdbutton(true)
  }

  function HandleModif() {
    setEnrege(false);
    setModife(true);
    setActue(false);
    setAnnule(false)
    setFormactve(false);
    setSbmit('modif');
    setSupprime(true);
    setIdbutton(true);
    setIdlibell(false);
  }

  function HandleSupp() {
    setSbmit('supp');
  }

  function HandleAnnul() {

    setConsulte(false);
    setAjoute(false);
    setModife(true);
    setEnrege(true);
    setSupprime(true);
    setActue(true);
    setAnnule(true);
    form.resetFields();
    setFormactve(true);
    setSbmit('');
    setIdlibell(true);
    setIdbutton(false)
  }



  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Limite
        </span>
      ),
      children: <>

        <div className='tabItem' >
          <div style={{ display: 'block flow' }}  >
            <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
              <legend> Mise en place des Banques </legend>
              <Box style={{ display: "flex" }} >
                <Box style={{ marginTop: -10, width: '100%' }}>
                  <Box style={{ marginTop: -10 }}>
                    <SearchInput dissabledCode={Idbutton} notRequired Taille1={'100%'} Taille2={0} width={6} Titre=" Recherche " label={FormLimite.NumOdre} name="IDLIMITE" Parametre={searchLim}  /*etat={props.setSearchGlobal} */ form={form} />
                  </Box>
                  <Box style={{ marginTop: -10 }}>
                    <SearchModal Titre="Recherche" width={6} Taille1={'100%'} Taille2={'100%'} label={FormLimite.Idclient} name="IDClient" Parametre={searchClient} form={form} />
                  </Box>
                  <Box style={{ marginTop: -10, width: '68%' }}>
                    <InputForm width={9} label={FormLimite.datedebut} defaultValue={Perss.datjour} name="datedebut" type="date" />
                  </Box>
                </Box>
                <Box style={{ marginTop: -10, width: '100%' }}>
                  <Box style={{ marginTop: -10, width: '80%' }}>
                    <InputForm width={10} disabled notRequired label={FormLimite.Nivcons} name="NivCons" type="number" />
                  </Box>
                  <Box style={{ marginTop: -12, width: '80%' }}>
                    <InputForm width={10} label={FormLimite.Mntlim} name="MNTlimite" type="number" />
                  </Box>
                  <Box style={{ marginTop: -10, width: '80%' }}>
                    <InputForm width={10} label={FormLimite.datefin} defaultValue={Perss.datjour} name="datefin" type="date" />
                  </Box>
                </Box>
              </Box>
              <Box style={{ marginTop: -12, width: '90%' }}>
                <InputForm label={"Motif Limite"} width={3} name="Motif" type="text" />
              </Box>
            </Box>
          </div>
        </div >



      </>,
    }
  ];


  const onFinish = (values: any) => {

    //console.log(values)
    var limite: MLimite = values
    limite.utisai = Perss.coduti;
    limite.codeage = Perss.codage;
    //alert(limite.datedebut)
    limite.datedebut =formatDate(limite.datedebut)
    //alert(limite.datedebut)
    limite.datefin = formatDate(limite.datefin)
    limite.datcre = formatDate(Perss.datjour);
    
    let data = Crypter.encrypt(JSON.stringify(limite));
    let data2 = Crypter.encrypt(JSON.stringify(values.IDLIMITE));

    if (limite.datedebut >= limite.datefin) {
      SweetAlert.fire({ text: " Opération Impossible : la date debut de la limite doit être inférieur à la date de fin de la limite ", icon: "warning" })
    } else if (form.getFieldValue("MNTlimite") < 0) {
      SweetAlert.fire({ text: " Opération Impossible : le montant de la limite doit être positif ", icon: "warning" })
    } else {
      if (sbmit == "add") {

        if (limite.datedebut < Perss.datjour) {
          SweetAlert.fire({ text: " Opération Impossible : impossible la date debut doit être supérieur a la date comptable ", icon: "warning" })
        } else {
          SweetAlert.fire({
            title: "Création d'une Limite",
            text: "Voulez-vous enregistrer la Limite de  " + values.lib_IDClient + " ?",
            showCancelButton: true,
            color: "#116599",
            confirmButtonText: "Yes",
            confirmButtonColor: "#116599",
            cancelButtonColor: "darkred",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            icon: "question"
          }).then((res) => {

            if (res.isConfirmed) {
              setLoading(true);
              setIsSubmit(true)



              let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.CreateLimite,
                headers: {
                  'CypherLimite': data,
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json'
                },
                data: data
              };
              axios.request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data));
                    let code = res.Result

                    if (res.StatutCode == 200) {

                      if (code == 'use') {
                        SweetAlert.fire({ title: '', text: "Modification Impossible : La limite à déja étè Utilisé", icon: "warning" })
                      } else if (code == 'ErreurJr') {
                        SweetAlert.fire({ title: '', text: "Modification Impossible : La Journée Comptable N'est pas Ouverte", icon: "warning" })
                      } else if (code == 'Existe') {
                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                      } else {

                        HandleAnnul()
                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                      }

                    }
                    else {
                      SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error)
                  SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                });
            }
          })
        }
      }

      // ********************************************************************************************************************************
      if (sbmit == "modif") {
        SweetAlert.fire({
          title: "Mise à Jour Limite",
          text: "Voulez-vous modifier la limite de " + values.lib_IDClient + " ?",
          showCancelButton: true,
          color: "#116599",
          confirmButtonText: "Yes",
          confirmButtonColor: "#116599",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: "question"
        }).then((res) => {

          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)

            let config = {
              method: 'put',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.UpdateLimite,
              headers: {
                'CypherLimite': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: data
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data));
                  //console.log(res)
                  if (res.StatutCode == 200) {
                    let code = res.Result

                    if (res.Message == 'use') {
                      SweetAlert.fire({ title: '', text: "Modification Impossible : La limite à déja étè Utilisé", icon: "warning" })
                    } else if (res.Message == 'ErreurJr') {
                      SweetAlert.fire({ title: '', text: "Modification Impossible : La Journée Comptable N'est pas Ouverte", icon: "warning" })
                    } else {

                      HandleAnnul()
                      SweetAlert.fire({ title: '', text: "Mise à jour éffectuer avec Succes : Reference " + res.Message, icon: "success" })
                    }

                  }
                  else {
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
              });
          }
        })
      }

      // ********************************************************************************************************************************
      if (sbmit == "supp") {

        SweetAlert.fire({
          title: "Suppression d'une Limite",
          text: "Voulez-vous Supprimer la limite de :" + values.lib_IDClient + " ?",
          showCancelButton: true,
          color: "#116599",
          confirmButtonText: "Yes",
          confirmButtonColor: "#116599",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: "question"
        }).then((res) => {

          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)
            let config = {
              method: 'delete',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.DeleteLimite,
              headers: {
                'CypherNumordre': data2,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: data
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data));
                  //console.log(res)
                  if (res.StatutCode == 200) {
                    let code = res.Result

                    if (res.Message == 'use') {
                      SweetAlert.fire({ title: '', text: "Suppression Impossible : La limite à déja étè Utilisé", icon: "warning" })
                    } else if (res.Message == 'ErreurJr') {
                      SweetAlert.fire({ title: '', text: "Suppression Impossible : La Journée Comptable N'est pas Ouverte", icon: "warning" })
                    } else {

                      HandleAnnul()
                      SweetAlert.fire({ title: '', text: "Suppression effectuer avec Succès: " + res.Message, icon: "success" })
                    }

                  }
                  else {
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
              });
          }
        })
      }
    }
  }



  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {

    if (form.getFieldValue("IDLIMITE") == null) {
      SweetAlert.fire({ title: "Warning", text: 'Svp Renseigner la reference de la Limite', icon: "warning" })
    } else {
      let data = Crypter.encrypt(form.getFieldValue("IDLIMITE"));
      let IDLIMITE = form.getFieldValue("IDLIMITE")
      if (data.length != 0) {

        setLoading(true)
        form.resetFields()
        form.setFieldValue("IDLIMITE", IDLIMITE)
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadLimite,
          headers: {
            'CypherNumordre': data,
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
          //data: data
        };
        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data));
              //console.log(JSON.stringify(res))
              let limite = res.Result.Table[0]
              //console.log(JSON.stringify(limite))

              if (res.StatutCode == 200) {
                console.log(limite)
                form.setFieldsValue(limite);
                //console.log(form.getFieldsValue()

                form.setFieldValue('datedebut', ReformatDate(limite.datedebut));
                // form.setFieldValue('datefin', ReformatDate(limite.datefin));
                form.setFieldValue("datefin", ReformatDate(limite.datefin));
                HandleConsult()
              }
              else {
                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
              }
            }
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          });
      }
    }

  }

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>GESTION DES LIMITES </b></Typography>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Imprimer
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button> */}

                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult(); }} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default AddLimite;